<template>
    <div class='w-full pb-10 flex flex-col'
        style='min-height: calc(100vh - 80px);'
    >
        <div class="w-full bg-transparent lg:border-b border-grey-500 lg:max-h-16">
            <slot name='tabs' />
        </div>

        <slot />
    </div>
</template>